import React from "react";
import p1 from "../../Media/compare_iphone_14_pro__cjmfbiggqhpy_large.jpg";
import p2 from "../../Media/compare_iphone_14__ct4sjk962pea_large.jpg";
import p3 from "../../Media/compare_iphone_13__fqzwhmfmroey_large.jpg";
import p4 from "../../Media/compare_iphone_se__d5blqx1pgymq_large.jpg";

const Automation = () => {
  return (
    <div className="bg-white" id="Contact">
        <h2 className="text-3xl md:text-5xl text-center w-11/12 mx-auto font-bold py-10">Which iPhone is right for you?</h2>
      <div className="md:w-10/12 w-11/12 mx-auto grid grid-cols-12 gap-3 py-5">
        

        <div class="md:col-span-3 col-span-12 bg-white border border-gray-200 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700">
          <a data-aos="zoom-in" data-aos-duration="1000" className="flex justify-center" href="#">
            <img class="rounded-t-lg" src={p1} alt="" />
          </a>
          <div class="p-5 text-center">
            <p className="text-red-600 my-3">New</p>
            <h3 className="text-3xl font-bold">iPhone 14 Pro</h3>
            <h5 className="text-lg">The ultimate iPhone.</h5>
            <p className="mt-10 mb-5">From $999</p>
            <div>
              <button className="bg-primary-600 hover:bg-primary-700 text-white px-5 py-1.5 rounded-3xl mr-5">
                Buy
              </button>
            </div>
            <div className="flex justify-center mt-3">
              <button className="text-2xl text-primary-600 flex items-center">
                Learn more
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.25 4.5l7.5 7.5-7.5 7.5"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>


        <div class="md:col-span-3 col-span-12 bg-white border border-gray-200 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700">
          <a data-aos="zoom-in" data-aos-duration="1000" className="flex justify-center" href="#">
            <img class="rounded-t-lg" src={p2} alt="" />
          </a>
          <div class="p-5 text-center">
            <p className="text-red-600 my-3">New</p>
            <h3 className="text-3xl font-bold">iPhone 14</h3>
            <h5 className="text-lg">A total powerhouse.</h5>
            <p className="mt-10 mb-5">From $799</p>
            <div>
              <button className="bg-primary-600 hover:bg-primary-700 text-white px-5 py-1.5 rounded-3xl mr-5">
                Buy
              </button>
            </div>
            <div className="flex justify-center mt-3">
              <button className="text-2xl text-primary-600 flex items-center">
                Learn more
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.25 4.5l7.5 7.5-7.5 7.5"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>


        <div class="md:col-span-3 col-span-12 bg-white border border-gray-200 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700">
          <a data-aos="zoom-in" data-aos-duration="1000" className="flex justify-center" href="#">
            <img class="rounded-t-lg" src={p3} alt="" />
          </a>
          <div class="p-5 text-center">
            <p className="text-red-600 my-3">New</p>
            <h3 className="text-3xl font-bold">iPhone 13</h3>
            <h5 className="text-lg">As amazing as ever.</h5>
            <p className="mt-10 mb-5">From $599</p>
            <div>
              <button className="bg-primary-600 hover:bg-primary-700 text-white px-5 py-1.5 rounded-3xl mr-5">
                Buy
              </button>
            </div>
            <div className="flex justify-center mt-3">
              <button className="text-2xl text-primary-600 flex items-center">
                Learn more
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.25 4.5l7.5 7.5-7.5 7.5"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>


        <div class="md:col-span-3 col-span-12 bg-white border border-gray-200 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700">
          <a data-aos="zoom-in" data-aos-duration="1000" className="flex justify-center" href="#">
            <img class="rounded-t-lg" src={p4} alt="" />
          </a>
          <div class="p-5 text-center">
            <p className="text-red-600 my-3">New</p>
            <h3 className="text-3xl font-bold">iPhone</h3>
            <h5 className="text-lg">Serious power. Serious value.</h5>
            <p className="mt-10 mb-5">From $529</p>
            <div>
              <button className="bg-primary-600 hover:bg-primary-700 text-white px-5 py-1.5 rounded-3xl mr-5">
                Buy
              </button>
            </div>
            <div className="flex justify-center mt-3">
              <button className="text-2xl text-primary-600 flex items-center">
                Learn more
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.25 4.5l7.5 7.5-7.5 7.5"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>


      </div>
    </div>
  );
};

export default Automation;
